"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1943],{

/***/ 80672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ ConnectWalletButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30068);
/* harmony import */ var components_primitives_Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48027);
/* harmony import */ var components_primitives_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25347);




const ConnectWalletButton = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_rainbow_me_rainbowkit__WEBPACK_IMPORTED_MODULE_3__/* .ConnectButton.Custom */ .NL.Custom, {
        children: (param)=>{
            let { account , chain , openConnectModal , mounted  } = param;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Box__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                style: {
                    flex: "1",
                    display: "flex",
                    justifyContent: "flex"
                },
                children: (()=>{
                    if (!mounted || !account || !chain) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            css: {
                                flex: 1,
                                justifyContent: "center"
                            },
                            corners: "rounded",
                            onClick: openConnectModal,
                            type: "button",
                            children: "Connect Wallet"
                        });
                    }
                })()
            });
        }
    });
};


/***/ }),

/***/ 51943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30758);
/* harmony import */ var _navbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42927);



const Layout = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            css: {
                background: "$neutralBg",
                height: "100%",
                minHeight: "100vh",
                pt: 80
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                css: {
                    maxWidth: 4500,
                    mx: "auto"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navbar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                        children: children
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 56373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30758);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5678);




const CopyText = (param)=>{
    let { children , text , css  } = param;
    const [value, copy] = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_3__/* .useCopyToClipboard */ .m9)();
    const [isCopied, setIsCopied] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [open, setOpen] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const handleCopy = ()=>{
        copy(text);
        setIsCopied(true);
        setTimeout(()=>setIsCopied(false), 1000);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        sideOffset: 0,
        open: open,
        align: "center",
        side: "top",
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
            style: "body3",
            as: "p",
            children: isCopied ? "Copied!" : "Copy"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
            onClick: (e)=>{
                e.preventDefault();
                handleCopy();
            },
            onMouseEnter: ()=>setOpen(true),
            onMouseLeave: ()=>setOpen(false),
            onTouchStart: ()=>{
                handleCopy();
                setOpen(true);
                setTimeout(()=>setOpen(false), 1000);
            },
            css: {
                width: "100%",
                cursor: "pointer",
                height: "min-content",
                ...css
            },
            children: children
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CopyText);


/***/ }),

/***/ 18491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ FullscreenModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives_Dialog__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39114);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60430);



const FullscreenModal = (param)=>{
    let { trigger , children , open , onOpenChange  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .Root */ .fC, {
        modal: false,
        open: open,
        onOpenChange: onOpenChange,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .DialogTrigger */ .hg, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_2__/* .DialogPortal */ .PK, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Dialog__WEBPACK_IMPORTED_MODULE_1__/* .Content */ .VY, {
                    onInteractOutside: (e)=>{
                        e.preventDefault();
                    },
                    css: {
                        width: "100%",
                        height: "100%",
                        borderRadius: "0px",
                        border: "0px",
                        minWidth: "100%",
                        maxWidth: "100vw",
                        maxHeight: "100vh",
                        top: 0
                    },
                    children: children
                })
            })
        ]
    });
};


/***/ }),

/***/ 74431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ spin; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86744);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30758);



const spin = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .keyframes */ .F4)({
    "0%": {
        transform: "rotate(0deg)"
    },
    "100%": {
        transform: "rotate(360deg)"
    }
});
const LoadingSpinner = (param)=>{
    let { css  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        css: {
            width: 40,
            height: 40,
            border: "5px solid transparent",
            borderBottomColor: "$primary9",
            borderRightColor: "transparent",
            borderRadius: "50%",
            display: "inline-block",
            animation: "".concat(spin, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite"),
            ...css
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadingSpinner);


/***/ }),

/***/ 44930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ OpenSeaVerified; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30758);


const OpenSeaVerified = (param)=>{
    let { openseaVerificationStatus  } = param;
    if (openseaVerificationStatus === "verified") return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .u, {
        sideOffset: 4,
        content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
            style: "body3",
            css: {
                display: "block"
            },
            children: "Verified by OpenSea"
        }),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            src: "/icons/opensea-verified.svg"
        })
    });
    else return null;
};


/***/ }),

/***/ 42927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ik": function() { return /* binding */ NAVBAR_HEIGHT; },
  "t7": function() { return /* binding */ NAVBAR_HEIGHT_MOBILE; },
  "ZP": function() { return /* binding */ navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/primitives/index.ts + 10 modules
var primitives = __webpack_require__(30758);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/index.js
var dist = __webpack_require__(44111);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(82010);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var Img = __webpack_require__(68916);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tooltip/dist/index.mjs + 14 modules
var react_tooltip_dist = __webpack_require__(26123);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(79569);
// EXTERNAL MODULE: ./utils/chains.ts + 1 modules
var chains = __webpack_require__(79062);
// EXTERNAL MODULE: ./components/primitives/Tooltip.tsx
var Tooltip = __webpack_require__(56472);
;// CONCATENATED MODULE: ./components/navbar/SearchChainSwitcher.tsx







const SearchChainSwitcher = (param)=>{
    let { searchChain , setSearchChain  } = param;
    const isMounted = (0,hooks/* useMounted */.s4)();
    const { theme  } = (0,index_module/* useTheme */.F)();
    if (!isMounted || chains/* default.length */.Z.length === 1) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroup */.tX, {
        type: "single",
        value: searchChain,
        css: {
            pb: "$1",
            borderRadius: 0,
            gap: 0,
            overflow: "auto",
            width: "100%",
            justifyContent: "space-between"
        },
        children: chains/* default.map */.Z.map((chainOption)=>{
            /*#__PURE__*/ return (0,jsx_runtime.jsxs)(react_tooltip_dist/* Root */.fC, {
                delayDuration: 0,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_tooltip_dist/* Trigger */.xz, {
                        style: {
                            width: "100%",
                            minWidth: 60
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* ToggleGroupItem */.GX, {
                            asChild: true,
                            value: chainOption.routePrefix,
                            disabled: chainOption.routePrefix === searchChain,
                            onClick: ()=>{
                                setSearchChain(chainOption.routePrefix);
                            },
                            css: {
                                backgroundColor: "transparent",
                                px: "$4",
                                borderRadius: 0,
                                width: "100%",
                                zIndex: 9999,
                                borderBottom: "1px solid $gray5",
                                "&[data-state=on]": {
                                    backgroundColor: "transparent",
                                    borderBottom: "2px solid $primary9"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                css: {
                                    display: "flex",
                                    flexShrink: 0,
                                    justifyContent: "center",
                                    width: "max-content"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: theme === "dark" ? chainOption.darkIconUrl : chainOption.lightIconUrl,
                                    style: {
                                        height: 20,
                                        flexShrink: 0
                                    }
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_tooltip_dist/* Content */.VY, {
                        sideOffset: -4,
                        side: "top",
                        align: "center",
                        style: {
                            zIndex: 100,
                            filter: "drop-shadow(0px 3px 8px rgba(0, 0, 0, 0.3))"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* TooltipArrow */.C, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    zIndex: 9999,
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0px 1px 5px rgba(0,0,0,0.2)",
                                    borderRadius: 8,
                                    overflow: "hidden"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        background: "$neutralBgSubtle",
                                        p: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body3",
                                        as: "p",
                                        children: chainOption === null || chainOption === void 0 ? void 0 : chainOption.name
                                    })
                                })
                            })
                        ]
                    })
                ]
            }, chainOption.name);
        })
    });
};

// EXTERNAL MODULE: ./context/ChainContextProvider.tsx
var ChainContextProvider = __webpack_require__(43810);
// EXTERNAL MODULE: ./utils/titleCase.ts
var titleCase = __webpack_require__(68437);
;// CONCATENATED MODULE: ./components/navbar/GlobalSearch.tsx


















const CollectionItem = (param)=>{
    let { collection , handleSelectResult  } = param;
    const { theme  } = (0,index_module/* useTheme */.F)();
    const tokenCount = (0,react.useMemo)(()=>(0,numbers/* formatNumber */.uf)(collection.tokenCount), [
        collection.tokenCount
    ]);
    const collectionImage = (0,react.useMemo)(()=>{
        return (0,optimizeImage/* default */.Z)(collection.image, 250);
    }, [
        collection.image
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(collection.chainRoutePrefix, "/collection/").concat(collection.collectionId),
        style: {
            overflow: "hidden",
            width: "100%",
            minWidth: 0
        },
        onClick: ()=>handleSelectResult(collection),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                p: "$2",
                gap: "$3",
                cursor: "pointer",
                borderRadius: 4,
                "&:hover": {
                    background: "$gray4"
                },
                minWidth: 0,
                width: "100%"
            },
            align: "center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                    src: collectionImage,
                    style: {
                        width: 36,
                        height: 36,
                        borderRadius: 4
                    },
                    width: 36,
                    height: 36,
                    alt: "Searchbar Collection Image"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        minWidth: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    ellipsify: true,
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                    openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        height: 12,
                                        minWidth: "max-content"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: theme === "dark" ? collection.darkChainIcon : collection.lightChainIcon,
                                        style: {
                                            height: 12
                                        }
                                    })
                                }),
                                tokenCount && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                    style: "subtitle3",
                                    color: "subtle",
                                    children: [
                                        tokenCount,
                                        " items"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                collection.volumeCurrencySymbol && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        ml: "auto",
                        flexShrink: 0,
                        gap: "$1"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCrypto */.BH, {
                            textStyle: "subtitle2",
                            amount: collection.allTimeVolume,
                            decimals: collection.volumeCurrencyDecimals,
                            maximumFractionDigits: 2
                        }),
                        collection.volumeCurrencySymbol
                    ]
                })
            ]
        })
    });
};
const WalletItem = (param)=>{
    let { wallet  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/portfolio/".concat(wallet.address),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                p: "$2",
                gap: "$4",
                borderRadius: 4,
                "&:hover": {
                    background: "$gray4"
                }
            },
            align: "center",
            children: [
                wallet.avatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: wallet.avatar,
                    style: {
                        width: 32,
                        height: 32,
                        borderRadius: 4
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                    diameter: 32,
                    seed: (0,dist.jsNumberForAddress)(wallet.address)
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "subtitle1",
                    children: wallet.displayName
                })
            ]
        })
    });
};
const SearchResult = (param)=>{
    let { result , handleSelectResult  } = param;
    if (result.type == "collection") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionItem, {
            collection: result.data,
            handleSelectResult: handleSelectResult
        });
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WalletItem, {
            wallet: result.data
        });
    }
};
const GlobalSearch = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>{
    let { children , ...props } = param;
    const { chain  } = (0,react.useContext)(ChainContextProvider/* ChainContext */.p);
    const [searching, setSearching] = (0,react.useState)(false);
    const [search, setSearch] = (0,react.useState)("");
    const [searchChain, setSearchChain] = (0,react.useState)(chain.routePrefix);
    const [results, setResults] = (0,react.useState)([]);
    const [fallbackResults, setFallbackResults] = (0,react.useState)([]);
    const [recentResults, setRecentResults] = (0,react.useState)([]);
    const [showSearchBox, setShowSearchBox] = (0,react.useState)(false);
    const hasResults = results.length > 0 || fallbackResults.length > 0;
    const hasRecentResults = recentResults.length > 0;
    const debouncedSearch = (0,esm/* useDebounce */.Nr)(search, 500);
    const isMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 960px)"
    });
    (0,react.useEffect)(()=>{
        const getSearchResults = async ()=>{
            setSearching(true);
            let res = await fetch("/api/globalSearch?query=".concat(debouncedSearch, "&searchChain=").concat(searchChain)).then((res)=>res.json());
            setResults(res.results);
            setFallbackResults(res.fallbackResults);
            setSearching(false);
        };
        if (debouncedSearch.length >= 2) {
            getSearchResults();
        } else {
            setResults([]);
        }
    }, [
        debouncedSearch,
        searchChain
    ]);
    (0,react.useEffect)(()=>{
        const hideBox = ()=>setShowSearchBox(false);
        window.addEventListener("click", hideBox);
    }, []);
    // Get recent search results from local storage
    (0,react.useEffect)(()=>{
        const storedRecentResults = localStorage.getItem("recentResults");
        if (storedRecentResults) {
            let results = JSON.parse(storedRecentResults);
            //migration code for results that are missing data
            results = results.filter((result)=>result.allTimeVolume !== undefined && result.volumeCurrencySymbol !== undefined && result.tokenCount !== undefined);
            setRecentResults(results);
        }
    }, []);
    // Add selected collection to recent results
    const handleSelectResult = (selectedResult)=>{
        if (!recentResults.find((result)=>result.collectionId === selectedResult.collectionId)) {
            setRecentResults([
                selectedResult,
                ...recentResults.slice(0, 4)
            ]);
        }
        setShowSearchBox(false);
    };
    // Store recently selected results in local storage
    (0,react.useEffect)(()=>{
        localStorage.setItem("recentResults", JSON.stringify(recentResults));
    }, [
        recentResults
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        onClick: (e)=>{
            e.stopPropagation();
        },
        css: {
            position: "relative",
            width: "100%"
        },
        onFocus: ()=>setShowSearchBox(true),
        children: [
            !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    position: "absolute",
                    top: "50%",
                    left: "$4",
                    zIndex: 2,
                    transform: "translate(0, -50%)",
                    color: "$gray11"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T
                })
            }),
            isMobile && search.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                css: {
                    justifyContent: "center",
                    width: "44px",
                    height: "44px",
                    position: "absolute",
                    right: "$4",
                    zIndex: 2,
                    color: "$gray10"
                },
                type: "button",
                size: "small",
                color: "ghost",
                onClick: ()=>setSearch(""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faXmark */.g82,
                    width: 16,
                    height: 16
                })
            }),
            !showSearchBox && !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    position: "absolute",
                    top: "50%",
                    right: "$4",
                    zIndex: 2,
                    transform: "translate(0, -50%)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    css: {
                        color: "$gray9",
                        display: "none",
                        "@bp1100": {
                            display: "block"
                        }
                    },
                    children: "⌘K"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                ...props,
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                css: {
                    pl: isMobile ? 80 : 48,
                    backgroundColor: isMobile ? "transparent" : "",
                    borderRadius: isMobile ? "$0" : "",
                    borderBottom: isMobile ? "1px solid $gray4" : "",
                    pb: isMobile ? "24px" : "",
                    $$focusColor: isMobile && "none",
                    "&[placeholder]": {
                        textOverflow: "ellipsis"
                    }
                },
                ref: forwardedRef
            }),
            (showSearchBox || isMobile) && (hasResults || hasRecentResults || searching) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    top: "100%",
                    left: 0,
                    right: 0,
                    p: "$3",
                    background: isMobile ? "transparent" : "$dropdownBg",
                    borderRadius: isMobile ? 0 : 8,
                    zIndex: 4,
                    mt: isMobile ? 0 : "$2",
                    border: isMobile ? "" : "1px solid $gray7",
                    overflow: "hidden",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchChainSwitcher, {
                        searchChain: searchChain,
                        setSearchChain: setSearchChain
                    }),
                    hasRecentResults && !hasResults && search.length <= 3 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        css: {
                            pt: "$2"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    ml: "$2"
                                },
                                style: "subtitle2",
                                color: "subtle",
                                children: "Recent"
                            }),
                            recentResults && recentResults.map((result)=>{
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(SearchResult, {
                                    result: {
                                        type: "collection",
                                        data: result
                                    },
                                    handleSelectResult: handleSelectResult
                                }, result === null || result === void 0 ? void 0 : result.collectionId);
                            })
                        ]
                    }),
                    results && results.slice(0, 6).map((result)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult, {
                            result: result,
                            handleSelectResult: handleSelectResult
                        })),
                    results.length === 0 && fallbackResults.length > 0 && !searching ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                style: "body2",
                                color: "subtle",
                                css: {
                                    textAlign: "center",
                                    py: "$5",
                                    justifySelf: "center"
                                },
                                children: [
                                    "There are no results on",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle2",
                                        children: (0,titleCase/* default */.Z)(searchChain)
                                    }),
                                    ". Here are the results on other chains."
                                ]
                            }),
                            fallbackResults.slice(0, 6).map((result)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult, {
                                    result: result,
                                    handleSelectResult: handleSelectResult
                                }))
                        ]
                    }) : null,
                    searching && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        align: "center",
                        justify: "center",
                        css: {
                            py: "$4"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                            css: {
                                width: 24,
                                height: 24,
                                borderWidth: "3px"
                            }
                        })
                    }),
                    !searching && results.length === 0 && fallbackResults.length === 0 && search.length > 3 && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            p: "$4"
                        },
                        children: "No Results"
                    })
                ]
            })
        ]
    });
});
/* harmony default export */ var navbar_GlobalSearch = (GlobalSearch);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hotkeys-hook/dist/react-hotkeys-hook.esm.js
var react_hotkeys_hook_esm = __webpack_require__(46977);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(80672);
;// CONCATENATED MODULE: ./components/navbar/NavItem.tsx



const NavItem = /*#__PURE__*/ (0,react.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
        ...props,
        ref: forwardedRef,
        css: {
            color: "$gray12",
            cursor: "pointer",
            fontWeight: 700,
            "&:hover": {
                color: "$gray11"
            }
        },
        as: "p",
        style: "subtitle1",
        children: children
    });
});
/* harmony default export */ var navbar_NavItem = (NavItem);

// EXTERNAL MODULE: ./components/primitives/Avatar.tsx
var Avatar = __webpack_require__(95715);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 15 modules
var react_dialog_dist = __webpack_require__(60430);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(38793);
// EXTERNAL MODULE: ./components/common/FullscreenModal.tsx
var FullscreenModal = __webpack_require__(18491);
// EXTERNAL MODULE: ./components/primitives/ToggleGroup.tsx + 20 modules
var ToggleGroup = __webpack_require__(25180);
;// CONCATENATED MODULE: ./components/navbar/ThemeSwitcher.tsx






const ThemeSwitcher = ()=>{
    const { theme , setTheme  } = (0,index_module/* useTheme */.F)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ToggleGroup/* ToggleGroup */.tX, {
            type: "single",
            defaultValue: "light",
            value: theme,
            css: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleGroup/* ToggleGroupItem */.GX, {
                    className: "ToggleGroupItem",
                    value: "light",
                    "aria-label": "Left aligned",
                    css: {
                        flex: 1,
                        width: 82
                    },
                    onClick: ()=>setTheme("light"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faSun */.enB,
                        width: 16,
                        height: 16
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleGroup/* ToggleGroupItem */.GX, {
                    className: "ToggleGroupItem",
                    value: "dark",
                    "aria-label": "Left aligned",
                    css: {
                        flex: 1,
                        width: 82
                    },
                    onClick: ()=>setTheme("dark"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faMoon */.DBF,
                        width: 16,
                        height: 16
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var navbar_ThemeSwitcher = (ThemeSwitcher);

// EXTERNAL MODULE: ./components/primitives/CryptoCurrencyIcon.tsx
var CryptoCurrencyIcon = __webpack_require__(72064);
// EXTERNAL MODULE: ./node_modules/@wagmi/chains/dist/index.mjs
var chains_dist = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 7 modules
var chunk_LAFZBYO7 = __webpack_require__(81342);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/constants/address.js
var constants_address = __webpack_require__(66373);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/utils/unit/formatUnits.js
var formatUnits = __webpack_require__(60263);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.mjs + 23 modules
var reservoir_kit_ui_dist = __webpack_require__(17175);
;// CONCATENATED MODULE: ./components/navbar/Wallet.tsx








//CONFIGURABLE: Here you may configure currencies that you want to display in the wallet menu. Native currencies,
//like ETH/MATIC etc need to be fetched in a different way. Configure them below
const currencies = [
    {
        address: constants_address/* zeroAddress */.D,
        symbol: "ETH",
        decimals: chains_dist/* mainnet.nativeCurrency.decimals */.RJ.nativeCurrency.decimals,
        chain: {
            id: chains_dist/* mainnet.id */.RJ.id,
            name: chains_dist/* mainnet.name */.RJ.name
        },
        coinGeckoId: "ethereum"
    },
    {
        address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
        symbol: "WETH",
        decimals: chains_dist/* mainnet.nativeCurrency.decimals */.RJ.nativeCurrency.decimals,
        chain: {
            id: chains_dist/* mainnet.id */.RJ.id,
            name: chains_dist/* mainnet.name */.RJ.name
        },
        coinGeckoId: "weth"
    },
    {
        address: constants_address/* zeroAddress */.D,
        symbol: "MATIC",
        decimals: chains_dist/* polygon.nativeCurrency.decimals */.yu.nativeCurrency.decimals,
        chain: {
            id: chains_dist/* polygon.id */.yu.id,
            name: chains_dist/* polygon.name */.yu.name
        },
        coinGeckoId: "matic-network"
    },
    {
        address: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
        symbol: "WETH",
        decimals: chains_dist/* polygon.nativeCurrency.decimals */.yu.nativeCurrency.decimals,
        chain: {
            id: chains_dist/* polygon.id */.yu.id,
            name: chains_dist/* polygon.name */.yu.name
        },
        coinGeckoId: "weth"
    },
    {
        address: "0x4200000000000000000000000000000000000006",
        symbol: "WETH",
        decimals: chains_dist/* optimism.nativeCurrency.decimals */.v4.nativeCurrency.decimals,
        chain: {
            id: chains_dist/* optimism.id */.v4.id,
            name: chains_dist/* optimism.name */.v4.name
        },
        coinGeckoId: "weth"
    }
];
const nonNativeCurrencies = currencies.filter((currency)=>currency.address !== constants_address/* zeroAddress */.D);
const currencySymbols = currencies.map((currency)=>currency.symbol).join(",");
const currencyCoingeckoIds = currencies.map((currency)=>currency.coinGeckoId).join(",");
const Wallet = ()=>{
    const [viewAll, setViewAll] = (0,react.useState)(false);
    const { address  } = (0,wagmi_dist/* useAccount */.mA)();
    const { data: nonNativeBalances  } = (0,wagmi_dist/* useContractReads */.Dm)({
        contracts: nonNativeCurrencies.map((currency)=>({
                abi: chunk_LAFZBYO7/* erc20ABI */.em,
                address: currency.address,
                chainId: currency.chain.id,
                functionName: "balanceOf",
                args: [
                    address
                ]
            })),
        watch: true,
        enabled: address ? true : false,
        allowFailure: false
    });
    //CONFIGURABLE: Configure these by just changing the chainId to fetch native balance info, in addition to changing this
    // also make sure you change the enhancedCurrencies function to take into account for these new balances
    const ethBalance = (0,wagmi_dist/* useBalance */.KQ)({
        address,
        chainId: chains_dist/* mainnet.id */.RJ.id
    });
    const maticBalance = (0,wagmi_dist/* useBalance */.KQ)({
        address,
        chainId: chains_dist/* polygon.id */.yu.id
    });
    const usdConversions = (0,reservoir_kit_ui_dist/* useCoinConversion */.sE)("USD", currencySymbols, currencyCoingeckoIds);
    const enhancedCurrencies = (0,react.useMemo)(()=>{
        const currencyToUsdConversions = usdConversions.reduce((map, data)=>{
            map[data.symbol] = data;
            map[data.coinGeckoId] = data;
            return map;
        }, {});
        return currencies.map((currency, i)=>{
            let balance = 0n;
            if (currency.address === constants_address/* zeroAddress */.D) {
                //CONFIGURABLE: Configure these to show the fetched balance results configured above in the useBalance hooks
                switch(currency.chain.id){
                    case chains_dist/* polygon.id */.yu.id:
                        {
                            var _maticBalance_data;
                            balance = ((_maticBalance_data = maticBalance.data) === null || _maticBalance_data === void 0 ? void 0 : _maticBalance_data.value) || 0n;
                            break;
                        }
                    case chains_dist/* mainnet.id */.RJ.id:
                        {
                            var _ethBalance_data;
                            balance = ((_ethBalance_data = ethBalance.data) === null || _ethBalance_data === void 0 ? void 0 : _ethBalance_data.value) || 0n;
                            break;
                        }
                }
            } else {
                const index = nonNativeCurrencies.findIndex((nonNativeCurrency)=>nonNativeCurrency.chain.id === currency.chain.id && nonNativeCurrency.symbol === currency.symbol && nonNativeCurrency.coinGeckoId === currency.coinGeckoId);
                balance = nonNativeBalances && nonNativeBalances[index] && (typeof nonNativeBalances[index] === "string" || typeof nonNativeBalances[index] === "number" || typeof nonNativeBalances[index] === "bigint") ? nonNativeBalances[index] : 0n;
            }
            const conversion = currencyToUsdConversions[currency.coinGeckoId.length > 0 ? currency.coinGeckoId : currency.symbol.toLowerCase()];
            const usdPrice = Number((0,formatUnits/* formatUnits */.b)(BigInt(balance), (currency === null || currency === void 0 ? void 0 : currency.decimals) || 18)) * ((conversion === null || conversion === void 0 ? void 0 : conversion.price) || 0);
            return {
                ...currency,
                usdPrice,
                balance
            };
        });
    //CONFIGURABLE: Configure these to regenerate whenever a native balance changes, non native balances are already handled
    }, [
        usdConversions,
        nonNativeBalances,
        ethBalance,
        maticBalance
    ]);
    const totalUsdBalance = (0,react.useMemo)(()=>{
        return enhancedCurrencies.reduce((total, param)=>{
            let { usdPrice  } = param;
            return total + usdPrice;
        }, 0);
    }, [
        enhancedCurrencies
    ]);
    const visibleCurrencies = viewAll ? enhancedCurrencies : enhancedCurrencies.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        direction: "column",
        align: "center",
        css: {
            background: "$gray2",
            border: "1px solid $gray3",
            borderRadius: 8,
            mt: "$3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    width: "100%",
                    height: 1,
                    background: "$gray1"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                direction: "column",
                align: "center",
                css: {
                    p: "$4",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "body2",
                        color: "subtle",
                        css: {
                            mb: "$2",
                            mt: "$2"
                        },
                        children: "Total Balance"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCurrency */.mz, {
                        style: "h4",
                        amount: totalUsdBalance,
                        css: {
                            mb: "$4"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center"
                        },
                        onClick: ()=>{
                            window.open("https://app.uniswap.org/", "_blank");
                        },
                        children: "Add Funds"
                    }),
                    visibleCurrencies.map((currency, i)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                width: "100%",
                                mt: 28,
                                gap: "$3"
                            },
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        width: 40,
                                        height: 40,
                                        background: "$gray3",
                                        borderRadius: 4,
                                        flexShrink: 0
                                    },
                                    align: "center",
                                    justify: "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CryptoCurrencyIcon/* default */.Z, {
                                        address: currency.address,
                                        chainId: currency.chain.id,
                                        css: {
                                            height: 24
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    justify: "center",
                                    css: {
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            justify: "between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body1",
                                                    children: currency.symbol
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCrypto */.BH, {
                                                    amount: currency.balance,
                                                    decimals: currency.decimals,
                                                    textStyle: "body1"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            justify: "between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body2",
                                                    color: "subtle",
                                                    children: currency.chain.name
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body2",
                                                    color: "subtle"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCurrency */.mz, {
                                                    amount: currency.usdPrice
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, i);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                        css: {
                            width: "100%",
                            justifyContent: "center",
                            mt: 24,
                            mb: "$3"
                        },
                        color: "gray3",
                        onClick: ()=>{
                            setViewAll(!viewAll);
                        },
                        children: [
                            "View ",
                            viewAll ? "Fewer" : "All",
                            " Tokens"
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var navbar_Wallet = (Wallet);

// EXTERNAL MODULE: ./utils/siteConfig.ts
var siteConfig = __webpack_require__(17634);
;// CONCATENATED MODULE: ./components/navbar/HamburgerMenu.tsx

















const HamburgerMenu = ()=>{
    const { address , isConnected  } = (0,wagmi_dist/* useAccount */.mA)();
    const { avatar: ensAvatar , shortAddress , shortName: shortEnsName  } = (0,hooks/* useENSResolver */.Af)(address);
    const { disconnect  } = (0,wagmi_dist/* useDisconnect */.qL)();
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: {
            justifyContent: "center",
            width: "44px",
            height: "44px"
        },
        type: "button",
        size: "small",
        color: "gray3",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faBars */.xiG,
            width: 16,
            height: 16
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    flexDirection: "column",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4"
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        width: 46,
                                        cursor: "pointer"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/reservoirLogo.svg",
                                        width: 36,
                                        height: 36,
                                        alt: "Reservoir"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faXmark */.g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            flexDirection: "column",
                            justifyContent: "flex-start",
                            height: "100%",
                            py: "$5",
                            px: "$4"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/portfolio/".concat(address),
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        pb: "$4"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        css: {
                                            alignItems: "center"
                                        },
                                        children: [
                                            ensAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                size: "medium",
                                                src: ensAvatar
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
                                                diameter: 36,
                                                seed: (0,dist.jsNumberForAddress)(address)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle1",
                                                css: {
                                                    ml: "$2"
                                                },
                                                children: shortEnsName ? shortEnsName : shortAddress
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/".concat(routePrefix, "/collection-rankings"),
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        borderBottom: "1px solid $gray4",
                                        cursor: "pointer",
                                        pb: "$4",
                                        pt: "24px"
                                    },
                                    children: "Explore"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/ethereum/collection-rankings",
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        borderBottom: "1px solid $gray4",
                                        cursor: "pointer",
                                        pb: "$4",
                                        pt: "24px"
                                    },
                                    children: "NFTs"
                                })
                            }),
                            (0,siteConfig/* isAdminWallet */.zM)(address) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/admin",
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    css: {
                                        borderBottom: "1px solid $gray4",
                                        cursor: "pointer",
                                        pb: "$4",
                                        pt: "24px"
                                    },
                                    children: "Admin"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                href: "mailto:info@dnld.us",
                                target: "_blank",
                                css: {
                                    borderBottom: "1px solid $gray4",
                                    cursor: "pointer",
                                    pb: "$4",
                                    pt: "24px",
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    style: "subtitle1",
                                    children: "Contact"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/portfolio",
                                legacyBehavior: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        borderBottom: "1px solid $gray4",
                                        cursor: "pointer",
                                        pb: "$4",
                                        pt: "24px",
                                        gap: "$1"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            children: "Portfolio"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body3",
                                            color: "subtle",
                                            children: "Manage your items, collections, listings and offers"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_Wallet, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    justifyContent: "space-between",
                                    cursor: "pointer",
                                    alignItems: "center",
                                    borderBottom: "1px solid $gray4"
                                },
                                onClick: ()=>disconnect(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle1",
                                        css: {
                                            pb: "$4",
                                            pt: "24px"
                                        },
                                        children: "Logout"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            color: "$gray10"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                            icon: free_solid_svg_icons/* faRightFromBracket */.mXR,
                                            width: 16,
                                            height: 16
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        direction: "column",
                        justify: "between",
                        css: {
                            height: "100%",
                            pb: "$5",
                            px: "$4"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            css: {
                                                borderBottom: "1px solid $gray4",
                                                cursor: "pointer",
                                                pb: "$4",
                                                pt: "24px",
                                                width: "100%"
                                            },
                                            children: "Explore"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/portfolio",
                                        legacyBehavior: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            css: {
                                                borderBottom: "1px solid $gray4",
                                                cursor: "pointer",
                                                pb: "$4",
                                                pt: "24px",
                                                width: "100%"
                                            },
                                            children: "Portfolio"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Anchor */.ee, {
                                        href: "https://my.dnld.us",
                                        target: "_blank",
                                        css: {
                                            borderBottom: "1px solid $gray4",
                                            cursor: "pointer",
                                            pb: "$4",
                                            pt: "24px",
                                            width: "100%"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            children: "Featured"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            pt: "24px",
                            pb: "$5",
                            px: "$4",
                            gap: "$4",
                            width: "100%",
                            borderTop: "1px solid $gray4"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://aux.digital",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px"
                                    },
                                    type: "button",
                                    size: "small",
                                    color: "gray3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_brands_svg_icons/* faBuysellads */.Z3j,
                                        width: 20,
                                        height: 20
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_ThemeSwitcher, {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var navbar_HamburgerMenu = (HamburgerMenu);

// EXTERNAL MODULE: ./components/primitives/Dialog.tsx
var Dialog = __webpack_require__(39114);
;// CONCATENATED MODULE: ./components/navbar/MobileSearch.tsx








const MobileSearch = ()=>{
    const children = /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: {
            flexDirection: "column",
            height: "100%",
            pt: "$4"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_GlobalSearch, {
                placeholder: "Search collections and addresses"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                css: {
                    position: "absolute",
                    top: "$4",
                    left: "$4"
                },
                align: "center",
                justify: "between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Close */.x8, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        css: {
                            justifyContent: "center",
                            width: "44px",
                            height: "44px",
                            alignItems: "center",
                            borderRadius: 8,
                            backgroundColor: "$gray3",
                            color: "$gray12",
                            "&:hover": {
                                backgroundColor: "$gray4"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                            icon: free_solid_svg_icons/* faChevronLeft */.A35,
                            width: 16,
                            height: 16
                        })
                    })
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* Root */.fC, {
        modal: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* DialogTrigger */.hg, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    css: {
                        justifyContent: "center",
                        width: "44px",
                        height: "44px"
                    },
                    type: "button",
                    size: "small",
                    color: "gray3",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* DialogPortal */.PK, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Content */.VY, {
                    onInteractOutside: (e)=>{
                        e.preventDefault();
                    },
                    css: {
                        width: "100%",
                        height: "100%",
                        borderRadius: "0px",
                        border: "0px",
                        minWidth: "100%",
                        maxWidth: "100vw",
                        maxHeight: "100vh",
                        top: "0%",
                        zIndex: 9999
                    },
                    children: children
                })
            })
        ]
    });
};
/* harmony default export */ var navbar_MobileSearch = (MobileSearch);

;// CONCATENATED MODULE: ./components/navbar/CartButton.tsx
// HIDDEN during the browse-only relaunch: native trading is parked and cart
// checkout executed via Reservoir, so the navbar cart renders nothing.
// To restore, render the disabled cart button again here.
const CartButton = ()=>{
    return null;
};
/* harmony default export */ var navbar_CartButton = (CartButton);

// EXTERNAL MODULE: ./node_modules/react-jazzicon/dist/Jazzicon.js
var Jazzicon = __webpack_require__(35342);
var Jazzicon_default = /*#__PURE__*/__webpack_require__.n(Jazzicon);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 167 modules
var motion = __webpack_require__(26718);
// EXTERNAL MODULE: ./components/common/CopyText.tsx
var CopyText = __webpack_require__(56373);
;// CONCATENATED MODULE: ./components/navbar/AccountSidebar.tsx


















const AccountSidebar = ()=>{
    const { address  } = (0,wagmi_dist/* useAccount */.mA)();
    const { disconnect  } = (0,wagmi_dist/* useDisconnect */.qL)();
    const router = (0,next_router.useRouter)();
    const { avatar: ensAvatar , shortAddress , shortName: shortEnsName  } = (0,hooks/* useENSResolver */.Af)(address);
    const [open, setOpen] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        setOpen(false);
    }, [
        router.asPath
    ]);
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
        css: {
            justifyContent: "center"
        },
        corners: "circle",
        type: "button",
        color: "gray3",
        children: ensAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
            size: "medium",
            src: ensAvatar
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((Jazzicon_default()), {
            diameter: 44,
            seed: (0,dist.jsNumberForAddress)(address)
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* Root */.fC, {
        onOpenChange: setOpen,
        open: open,
        children: [
            trigger && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* DialogTrigger */.hg, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                children: open && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_dialog_dist/* DialogPortal */.PK, {
                    forceMount: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* AnimatedOverlay */.Q3, {
                            css: {
                                backgroundColor: "$sidebarOverlay"
                            },
                            style: {
                                opacity: 0.6
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Dialog/* Content */.VY, {
                            forceMount: true,
                            asChild: true,
                            css: {
                                right: 0,
                                top: 0,
                                bottom: 0,
                                transform: "none",
                                left: "unset",
                                width: 395,
                                maxWidth: 395,
                                minWidth: 395,
                                maxHeight: "100vh",
                                background: "$gray1",
                                border: 0,
                                borderRadius: 0
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                                transition: {
                                    type: "tween",
                                    duration: 0.4
                                },
                                initial: {
                                    opacity: 0,
                                    right: "-100%"
                                },
                                animate: {
                                    opacity: 1,
                                    right: 0
                                },
                                exit: {
                                    opacity: 0,
                                    right: "-100%"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    direction: "column",
                                    css: {
                                        py: "$4",
                                        px: "$4"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            color: "ghost",
                                            css: {
                                                color: "$gray10",
                                                ml: "auto",
                                                mr: 10
                                            },
                                            onClick: ()=>{
                                                setOpen(false);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                icon: free_solid_svg_icons/* faClose */.YIN,
                                                height: 18,
                                                width: 18
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            align: "center",
                                            css: {
                                                gap: "$3",
                                                ml: "$3"
                                            },
                                            children: [
                                                ensAvatar ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* Avatar */.q, {
                                                    size: "large",
                                                    src: ensAvatar
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((Jazzicon_default()), {
                                                    diameter: 52,
                                                    seed: (0,dist.jsNumberForAddress)(address)
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyText/* default */.Z, {
                                                    text: address || "",
                                                    css: {
                                                        width: "max-content"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        direction: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                align: "center",
                                                                css: {
                                                                    gap: 8,
                                                                    color: "$gray11",
                                                                    cursor: "pointer"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                        style: "body1",
                                                                        children: shortEnsName ? shortEnsName : shortAddress
                                                                    }),
                                                                    !shortEnsName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: free_solid_svg_icons/* faCopy */.kZ_,
                                                                        width: 12,
                                                                        height: 14
                                                                    }) : null
                                                                ]
                                                            }),
                                                            shortEnsName ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                                align: "center",
                                                                css: {
                                                                    gap: 8,
                                                                    color: "$gray11",
                                                                    cursor: "pointer"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                        style: "body2",
                                                                        color: "subtle",
                                                                        children: shortAddress
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: free_solid_svg_icons/* faCopy */.kZ_,
                                                                        width: 12,
                                                                        height: 12
                                                                    })
                                                                ]
                                                            }) : null
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Grid */.rj, {
                                            css: {
                                                gridTemplateColumns: "1fr 1fr",
                                                mt: 32
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/portfolio?tab=items",
                                                    replace: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: 6,
                                                            p: "$3",
                                                            color: "$gray10",
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faStore */.vJI
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                children: "My Items"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/portfolio?tab=listings",
                                                    replace: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: 6,
                                                            p: "$3",
                                                            color: "$gray10",
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faList */.Zrf
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                children: "Listings"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/portfolio?tab=offers",
                                                    replace: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: 6,
                                                            p: "$3",
                                                            color: "$gray10",
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faHand */.ioV
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                children: "Offers Made"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/portfolio?tab=activity",
                                                    replace: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: 6,
                                                            p: "$3",
                                                            color: "$gray10",
                                                            cursor: "pointer"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                icon: free_solid_svg_icons/* faChartLine */.Stf
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                children: "Activity"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_Wallet, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                            css: {
                                                m: "$4",
                                                mt: "$5"
                                            },
                                            justify: "between",
                                            align: "center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                    style: "body1",
                                                    css: {
                                                        mb: "$2",
                                                        flex: 1
                                                    },
                                                    as: "p",
                                                    children: "Theme"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_ThemeSwitcher, {})
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                            size: "large",
                                            css: {
                                                my: "$4",
                                                justifyContent: "center"
                                            },
                                            color: "gray3",
                                            onClick: ()=>disconnect(),
                                            children: "Disconnect Wallet"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-hover-card/dist/index.mjs + 12 modules
var react_hover_card_dist = __webpack_require__(9843);
;// CONCATENATED MODULE: ./components/navbar/index.tsx




















const NAVBAR_HEIGHT = 81;
const NAVBAR_HEIGHT_MOBILE = 77;
const Navbar = ()=>{
    const { theme  } = (0,index_module/* useTheme */.F)();
    const { isConnected  } = (0,wagmi_dist/* useAccount */.mA)();
    const { address  } = (0,wagmi_dist/* useAccount */.mA)();
    const showAdminLink = (0,siteConfig/* isAdminWallet */.zM)(address);
    const isMobile = (0,react_responsive.useMediaQuery)({
        query: "(max-width: 960px"
    });
    const isMounted = (0,hooks/* useMounted */.s4)();
    const { routePrefix  } = (0,hooks/* useMarketplaceChain */.gw)();
    let searchRef = (0,react.useRef)(null);
    const router = (0,next_router.useRouter)();
    (0,react_hotkeys_hook_esm/* useHotkeys */.y1)("meta+k", (e)=>{
        e.preventDefault();
        if (searchRef === null || searchRef === void 0 ? void 0 : searchRef.current) {
            var _searchRef_current;
            searchRef === null || searchRef === void 0 ? void 0 : (_searchRef_current = searchRef.current) === null || _searchRef_current === void 0 ? void 0 : _searchRef_current.focus();
        }
    });
    if (!isMounted) {
        return null;
    }
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: {
            height: NAVBAR_HEIGHT_MOBILE,
            px: "$4",
            width: "100%",
            borderBottom: "1px solid $gray4",
            zIndex: 999,
            background: "$slate1",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0
        },
        align: "center",
        justify: "between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    flex: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                width: 46,
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/reservoirLogo.svg",
                                width: 199,
                                height: 63,
                                alt: "audi0"
                            })
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                css: {
                    gap: "$3"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_MobileSearch, {}, "".concat(router.asPath, "-search")),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_CartButton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_HamburgerMenu, {}, "".concat(router.asPath, "-hamburger"))
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: {
            height: NAVBAR_HEIGHT,
            px: "$5",
            "@xl": {
                px: "$6"
            },
            width: "100%",
            // maxWidth: 1920,
            mx: "auto",
            borderBottom: "1px solid $gray4",
            zIndex: 999,
            background: "$neutralBg",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0
        },
        align: "center",
        justify: "between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    flex: "unset",
                    "@bp1300": {
                        flex: 1
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    cursor: "pointer"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/reservoirLogo.svg",
                                    width: 199,
                                    height: 63,
                                    alt: "audi0"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            css: {
                                gap: "$5",
                                ml: "$5"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/drops",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                        children: "Drops"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/".concat(routePrefix, "#collections"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                        children: "NFTs"
                                    })
                                }),
                                showAdminLink && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/admin",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                        children: "Admin"
                                    })
                                }),
                                 false && /*#__PURE__*/ 0,
                                 false && /*#__PURE__*/ 0
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    flex: 1,
                    px: "$5"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_GlobalSearch, {
                    ref: searchRef,
                    placeholder: "Search collections and addresses",
                    containerCss: {
                        width: "100%"
                    }
                }, router.asPath)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    gap: "$3",
                    flex: "unset",
                    "@bp1300": {
                        flex: 1
                    }
                },
                justify: "end",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            gap: "$5",
                            mr: 12
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react_hover_card_dist/* Root */.fC, {
                                    openDelay: 120,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hover_card_dist/* Trigger */.xz, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: "https://dnld.us",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                                    children: "audi0 DApp"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_hover_card_dist/* Content */.VY, {
                                            sideOffset: 24,
                                            align: "start",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Card */.Zb, {
                                                css: {
                                                    p: 24,
                                                    width: 240
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: "$4"
                                                    },
                                                    direction: "column",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: "https://docs.dnld.us",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                                                children: "Docs"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: "_blank",
                                                            href: "https://matrix.to/#/#dnld:matrix.org",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                                                children: "User Support"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/portfolio",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        mr: "$2"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_NavItem, {
                                        children: "Portfolio"
                                    })
                                })
                            })
                        ]
                    }),
                    isConnected ? /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountSidebar, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                        css: {
                            maxWidth: "185px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(navbar_CartButton, {})
                ]
            })
        ]
    });
};
/* harmony default export */ var navbar = (Navbar);


/***/ }),

/***/ 95715:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ Avatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31139);
/* harmony import */ var _radix_ui_react_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);




const AvatarRoot = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_avatar__WEBPACK_IMPORTED_MODULE_3__/* .Root */ .fC, {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    verticalAlign: "middle",
    overflow: "hidden",
    userSelect: "none",
    flexShrink: 0,
    variants: {
        size: {
            xs: {
                size: 16
            },
            small: {
                size: 24
            },
            medium: {
                size: 36
            },
            large: {
                size: 48
            },
            xl: {
                size: 56
            },
            xxl: {
                size: 64
            }
        },
        corners: {
            rounded: {
                borderRadius: 4
            },
            circle: {
                borderRadius: "100%"
            }
        }
    },
    defaultVariants: {
        size: "medium",
        corners: "circle"
    }
});
const AvatarImage = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_avatar__WEBPACK_IMPORTED_MODULE_3__/* .Image */ .Ee, {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "inherit"
});
const AvatarFallback = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)(_radix_ui_react_avatar__WEBPACK_IMPORTED_MODULE_3__/* .Fallback */ .NY, {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "$gray1"
});
const Avatar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { size , corners , fallback , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(AvatarRoot, {
        size: size,
        corners: corners,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarImage, {
                ref: forwardedRef,
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AvatarFallback, {
                delayMs: 600,
                children: fallback
            })
        ]
    });
});


/***/ }),

/***/ 39114:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q3": function() { return /* binding */ AnimatedOverlay; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "hS": function() { return /* binding */ AnimatedContent; }
/* harmony export */ });
/* unused harmony exports Dialog, Overlay */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _stitches_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86744);
/* harmony import */ var _radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60430);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26718);





const Overlay = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .aV, {
    backgroundColor: "$neutralBg",
    position: "fixed",
    inset: 0,
    zIndex: 5000
});
const AnimatedOverlay = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, forwardedRef)=>{
    let { ...props } = param;
    var _props_style;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Overlay, {
        ...props,
        forceMount: true,
        asChild: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            transition: {
                duration: 0.5
            },
            initial: {
                opacity: 0
            },
            animate: {
                opacity: (_props_style = props["style"]) === null || _props_style === void 0 ? void 0 : _props_style.opacity
            },
            exit: {
                opacity: 0
            }
        })
    });
});
const Content = (0,_stitches_react__WEBPACK_IMPORTED_MODULE_2__/* .styled */ .zo)(_radix_ui_react_dialog__WEBPACK_IMPORTED_MODULE_3__/* .Content */ .VY, {
    backgroundColor: "$neutralBg",
    borderRadius: 8,
    $$shadowColor: "$colors$gray7",
    boxShadow: "box-shadow: 0px 2px 16px $$shadowColor",
    border: "1px solid $gray7",
    position: "fixed",
    top: "12.5%",
    left: "50%",
    transform: "translateX(-50%)",
    minWidth: 490,
    maxWidth: "90vw",
    maxHeight: "85vh",
    overflowY: "auto",
    "&:focus": {
        outline: "none"
    },
    zIndex: 5000
});
const AnimatedContent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, forwardedRef)=>/*#__PURE__*/ {
    let { children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Content, {
        forceMount: true,
        asChild: true,
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .motion.div */ .E.div, {
            ref: forwardedRef,
            transition: {
                type: "spring",
                duration: 0.5
            },
            initial: {
                opacity: 0,
                top: "14%"
            },
            animate: {
                opacity: 1,
                top: "9%"
            },
            exit: {
                opacity: 0,
                top: "14%"
            },
            children: children
        })
    });
});
const Dialog = /*#__PURE__*/ (/* unused pure expression or super */ null && (forwardRef((param, forwardedRef)=>{
    let { children , trigger , portalProps , overlayProps , open , onOpenChange , ...props } = param;
    const [_open, _onOpenChange] = useState(false);
    return /*#__PURE__*/ _jsxs(DialogPrimitive.Root, {
        onOpenChange: onOpenChange || _onOpenChange,
        open: open || _open,
        children: [
            trigger && /*#__PURE__*/ _jsx(DialogPrimitive.DialogTrigger, {
                asChild: true,
                children: trigger
            }),
            /*#__PURE__*/ _jsx(AnimatePresence, {
                children: open && /*#__PURE__*/ _jsxs(DialogPrimitive.DialogPortal, {
                    forceMount: true,
                    ...portalProps,
                    children: [
                        /*#__PURE__*/ _jsx(AnimatedOverlay, {
                            style: {
                                opacity: 1
                            },
                            ...overlayProps
                        }),
                        /*#__PURE__*/ _jsx(AnimatedContent, {
                            ref: forwardedRef,
                            ...props,
                            forceMount: true,
                            children: children
                        })
                    ]
                })
            })
        ]
    });
})));



/***/ }),

/***/ 68916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(59417);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99603);
/* harmony import */ var components_primitives_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20326);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31139);







const StyledImg = (0,stitches_config__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .zo)((next_image__WEBPACK_IMPORTED_MODULE_3___default()));
const defaultLoader = (param)=>{
    let { src  } = param;
    return src;
};
const Img = (props)=>{
    const [collectionImageBroken, setCollectionImageBroken] = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(()=>{
        if (collectionImageBroken) {
            setCollectionImageBroken(false);
        }
    }, [
        props.src
    ]);
    return collectionImageBroken || !props.src ? props.alt === "Collection Page Image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        css: {
            ...props.css,
            background: "$gray1"
        },
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faImage */ .VmB,
            size: "4x",
            width: props.width,
            height: props.height
        })
    }) : props.alt === "Activity Token Image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        css: {
            ...props.css,
            background: "$gray1"
        },
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faImage */ .VmB,
            size: "2x",
            width: props.width,
            height: props.height
        })
    }) : props.alt === "Searchbar Collection Image" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        css: {
            ...props.css,
            background: "$gray3"
        },
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faImage */ .VmB,
            size: "2x",
            width: props.width,
            height: props.height
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_primitives_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        css: {
            ...props.css,
            background: "$gray3"
        },
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_1__/* .FontAwesomeIcon */ .G, {
            icon: _fortawesome_free_solid_svg_icons__WEBPACK_IMPORTED_MODULE_6__/* .faImage */ .VmB,
            width: props.width,
            height: props.height
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StyledImg, {
        ...props,
        loader: props.loader || defaultLoader,
        onError: (e)=>{
            setCollectionImageBroken(true);
        }
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Img);


/***/ }),

/***/ 77497:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

const optimizeImage = (imageHref, width)=>{
    try {
        if (!imageHref) return "";
        let url = new URL(imageHref);
        const existingWidthRegex = /(w|width)=(\d+)/g;
        const existingWidth = imageHref.match(existingWidthRegex);
        if (existingWidth && existingWidth[0] && Number(existingWidth[0]) !== width) {
            return imageHref.replace(existingWidthRegex, (match, key, number)=>{
                return "".concat(key, "=").concat(width);
            });
        }
        if (url.host === "lh3.googleusercontent.com") {
            if (imageHref.includes("=s") || imageHref.includes("=w")) {
                let newImage = imageHref.split("=");
                return "".concat(newImage[0], "=w").concat(width);
            }
            return "".concat(imageHref, "=w").concat(width);
        } else if (url.host === "i.seadn.io") {
            if (imageHref.includes("w=")) {
                let newImage1 = imageHref.split("=");
                return "".concat(newImage1[0], "=").concat(width);
            }
            return "".concat(imageHref, "?w=").concat(width);
        } else if (url.host == "img.seadn.io") {
            if (imageHref.includes("w=")) {
                let newImage2 = imageHref.split("=");
                return "".concat(newImage2[0], "=").concat(width);
            }
            return "".concat(imageHref.replace("img.seadn.io/files", "i.seadn.io/gcs/files"), "?w=").concat(width);
        }
    } catch (e) {
        console.warn("Failed to optimize image", e);
    }
    return imageHref ? imageHref : "";
};
/* harmony default export */ __webpack_exports__["Z"] = (optimizeImage);


/***/ }),

/***/ 17634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "wN": function() { return /* binding */ adminSignMessage; },
/* harmony export */   "zM": function() { return /* binding */ isAdminWallet; }
/* harmony export */ });
/* unused harmony exports CONFIG_PATH, ADMIN_WALLETS, validateSiteCollections */
// Site collection curation: which collections the landing page features.
// The admin wallet holder edits this through /admin; the file is the source
// of truth and is read server-side at request time (never in the browser).
//
// NOTE: this module must stay free of Node built-ins (fs/path) because the
// admin page imports it into the client bundle. Server-only file reading
// lives in utils/siteConfig.server.ts.
const CONFIG_PATH = "config/collections.json";
// Admin wallets (checksummed or lowercase — compared case-insensitively).
const ADMIN_WALLETS = [
    "0xFA5b602B211D4CB638254920fD6A79A5C8A7C7Cb"
].map((a)=>a.toLowerCase());
const isAdminWallet = (address)=>!!address && ADMIN_WALLETS.includes(address.toLowerCase());
// Server-side file reading lives in utils/siteConfig.server.ts so this
// module stays importable from client components.
// Shared validation for admin writes: every value must be a 0x address.
const ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;
function validateSiteCollections(input) {
    if (!input || typeof input !== "object") return {
        ok: false,
        error: "Config must be an object."
    };
    const featured = {};
    const branded = [];
    const fIn = input.featured || {};
    const bIn = input.branded || [];
    if (typeof fIn !== "object" || Array.isArray(fIn)) return {
        ok: false,
        error: "featured must be an object."
    };
    for (const [chain, addr] of Object.entries(fIn)){
        if (typeof addr !== "string" || !ADDRESS_RE.test(addr)) return {
            ok: false,
            error: "Bad featured address for ".concat(chain, ".")
        };
        featured[chain] = addr;
    }
    // Branded is one unified list of {address, chain}. The legacy per-chain
    // object form {ethereum: [...], polygon: [...]} is normalized, not
    // rejected, so old payloads keep working.
    const bList = Array.isArray(bIn) ? bIn : typeof bIn === "object" ? Object.entries(bIn).flatMap((param)=>{
        let [chain, list] = param;
        return (Array.isArray(list) ? list : []).map((address)=>({
                address,
                chain
            }));
    }) : [];
    if (!Array.isArray(bIn) && (typeof bIn !== "object" || bIn === null)) return {
        ok: false,
        error: "branded must be a list."
    };
    const seen = [];
    for (const entry of bList){
        if (!entry || typeof entry !== "object" || Array.isArray(entry)) return {
            ok: false,
            error: "Bad branded entry."
        };
        const address = entry.address;
        const chain1 = typeof entry.chain === "string" ? entry.chain.toLowerCase() : "";
        if (typeof address !== "string" || !ADDRESS_RE.test(address)) return {
            ok: false,
            error: "Bad branded address: ".concat(address, ".")
        };
        if (!chain1) return {
            ok: false,
            error: "Bad branded chain for ".concat(address, ".")
        };
        const key = address.toLowerCase();
        if (seen.includes(key)) continue;
        seen.push(key);
        branded.push({
            address,
            chain: chain1
        });
    }
    // Optional artwork overrides keyed by lowercase contract address. Imported
    // from OpenSea; fills image/banner gaps Alchemy doesn't have.
    const artwork = {};
    const aIn = input.artwork || {};
    if (typeof aIn !== "object" || Array.isArray(aIn)) return {
        ok: false,
        error: "artwork must be an object."
    };
    for (const [addr1, art] of Object.entries(aIn)){
        if (!ADDRESS_RE.test(addr1)) return {
            ok: false,
            error: "Bad artwork address: ".concat(addr1, ".")
        };
        if (!art || typeof art !== "object" || Array.isArray(art)) return {
            ok: false,
            error: "Bad artwork entry for ".concat(addr1, ".")
        };
        const entry1 = {};
        for (const k of [
            "image",
            "banner"
        ]){
            const v = art[k];
            if (v == null || v === "") continue;
            if (typeof v !== "string" || !/^https:\/\//.test(v)) return {
                ok: false,
                error: "Bad artwork ".concat(k, " for ").concat(addr1, ".")
            };
            entry1[k] = v;
        }
        if (entry1.image || entry1.banner) artwork[addr1.toLowerCase()] = entry1;
    }
    return {
        ok: true,
        value: {
            featured,
            branded,
            artwork
        }
    };
}
// The exact message the admin wallet signs when publishing a config change.
const adminSignMessage = (configJson)=>"audi0 admin — publish site collections:\n".concat(configJson);


/***/ }),

/***/ 68437:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/**
 * Convert a word to title case
 * @param word - The word to convert to title case
 * @returns The input word in title case format
 */ function titleCase(word) {
    return word.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (titleCase);


/***/ })

}]);